import OauthButtons from "@/src/components/auth/oauth-buttons";
import OauthDivder from "@/src/components/auth/oauth-divider";
import ScButton from "@/src/components/ui-kit/button";
import InputField from "@/src/components/ui-kit/input-field.rhf";
import { useRegistration } from "@/src/hooks/features/auth/use-registration";
import { useTheme } from "@/src/styles/theme-provider";
import { useRef } from "react";
import {
  Image,
  Pressable,
  ScrollView,
  Text,
  TextInput,
  View,
} from "react-native";

export default function RegistrationScreen() {
  const { varStyle } = useTheme();
  const {
    control,
    handleSubmit,
    errors,
    isRegistering,
    onRegister,
    navigateToLogin,
    t,
  } = useRegistration();

  const lastNameRef = useRef<TextInput>(null);
  const emailRef = useRef<TextInput>(null);

  return (
    <View style={varStyle} className="flex-1 bg-chalk web:flex-row">
      <View className="hidden xl:flex flex-1 items-end justify-center p-8">
        <Image
          source={require("../../../assets/images/auth.png")}
          className="w-full h-full max-w-xl"
          resizeMode="contain"
        />
      </View>

      <View className="flex-1 items-center justify-center web:px-6 py-4">
        <ScrollView
          className="w-full"
          contentContainerClassName="items-start justify-center min-h-full"
          showsVerticalScrollIndicator={false}
        >
          <View className="w-full max-w-lg px-4 py-0">
            <View className="rounded-xl border border-ash-3 bg-chalk p-6 web:p-5">
              <View className="flex-row justify-center items-center mt-6 mb-4 web:mt-6 web:mb-3">
                <Image
                  source={require("../../../assets/images/club_logo.png")}
                  style={{ width: 28, height: 28 }}
                  resizeMode="contain"
                />
                <Text className="ml-2 text-primary text-2xl font-bold">
                  {t("LABEL_SELISE_LOGO")}
                </Text>
              </View>

              <Text className="web:text-xl text-2xl font-bold text-center mb-2 web:mb-1 text-onyx">
                {t("LABEL_REQUEST_JOIN")}
              </Text>
              <Text className="web:text-xs text-sm text-center text-slate mb-6 web:mb-4">
                {t("HINT_REQUEST_DESCRIPTION")}
              </Text>

              <View className="flex-row mb-2 gap-4">
                <View className="flex-1">
                  <InputField
                    showLabel
                    label={t("LABEL_FIRST_NAME")}
                    placeholder={t("LABEL_FIRST_NAME")}
                    control={control}
                    name="firstName"
                    backgroundColor="bg-obsidian"
                    error={errors.firstName?.message}
                    returnKeyType="next"
                    blurOnSubmit={false}
                    onSubmitEditing={() => lastNameRef.current?.focus()}
                  />
                </View>
                <View className="flex-1">
                  <InputField
                    ref={lastNameRef}
                    showLabel
                    label={t("LABEL_LAST_NAME")}
                    placeholder={t("LABEL_LAST_NAME")}
                    control={control}
                    name="lastName"
                    backgroundColor="bg-obsidian"
                    error={errors.lastName?.message}
                    returnKeyType="next"
                    blurOnSubmit={false}
                    onSubmitEditing={() => emailRef.current?.focus()}
                  />
                </View>
              </View>

              <InputField
                ref={emailRef}
                showLabel
                label={t("LABEL_EMAIL")}
                control={control}
                backgroundColor="bg-obsidian"
                name="email"
                keyboardType="email-address"
                error={errors.email?.message}
                placeholder={t("LABEL_EMAIL_PLACEHOLDER")}
                returnKeyType="go"
                onSubmitEditing={handleSubmit(onRegister)}
              />

              <ScButton
                text={
                  isRegistering ? "BTN_REQ_TO_JOIN_LOAD" : "BTN_REQ_TO_JOIN"
                }
                onPress={handleSubmit(onRegister)}
                disabled={isRegistering}
                loading={isRegistering}
                className="mb-6 h-16 web:h-10 web:mb-4 rounded-lg"
              />

              <OauthDivder />
              <OauthButtons />

              <View className="flex-row justify-center items-center mt-6 mb-6 web:mb-4 web:mt-4">
                <Text className="web:text-xs text-sm text-slate">
                  {t("QUEST_HAVE_ACCOUNT")}
                </Text>
                <Pressable
                  onPress={navigateToLogin}
                  className="hover:bg-ash-3 hover:rounded-lg"
                >
                  <Text className="ml-1 web:text-xs text-sm text-primary font-semibold">
                    {t("BTN_LOGIN")}
                  </Text>
                </Pressable>
              </View>
            </View>

            <View className="mt-12 items-center mb-6 web:mt-4 web:mb-2">
              <Image
                source={require("../../../assets/images/selise_logo.png")}
                style={{ width: 100, height: 36 }}
                resizeMode="contain"
              />
            </View>
          </View>
        </ScrollView>
      </View>
    </View>
  );
}
